class TradeInItem extends HTMLElement {
  constructor() {
    super();
  }

  createCreditRangeElement(minTradeInValue, maxTradeInValue, maxTradeInValuePrepromo) {
    const creditRangeMinEl = this.querySelector(".credit-min");
    if (creditRangeMinEl && typeof minTradeInValue === "number") {
      creditRangeMinEl.textContent = formatMoneyForTradein(minTradeInValue);
    }
    const creditRangeMaxEl = this.querySelector(".credit-max");
    if (typeof maxTradeInValue === "number") {
      creditRangeMaxEl.textContent = formatMoneyForTradein(maxTradeInValue);
    }
    if (maxTradeInValuePrepromo !== maxTradeInValue) {
      const creditRangeMaxPrepromoEl = this.querySelector(".credit-max-prepromo");
      creditRangeMaxPrepromoEl.textContent = formatMoneyForTradein(maxTradeInValuePrepromo);
      creditRangeMaxEl.style.fontWeight = 600;
      const promotionNote = document.querySelector(".trade-in-confirmation__promotion-note");
      if (promotionNote) {
        promotionNote.classList.remove('hidden');
      }
    }
  }

  renderDetails({
    parentSku,
    catalogItemTitle,
    initiatedSubcategory,
    isInitiatedConditionUnsellable,
    rejectedReason,
  }) {
    const styleNoLabel = TRADE_IN_CART_CONFIG.styleNoLabel;
    const itemNameEl = this.querySelector(".cart__item-details .item-name");
    itemNameEl.textContent = catalogItemTitle;
    const itemSkuEl = this.querySelector(".cart__item-details .item-sku");
    itemSkuEl.textContent = parentSku === '<unknown>' ? '' :  `${styleNoLabel}${parentSku}`;
    if (initiatedSubcategory) {
      const subcategoryEl = this.querySelector(".cart__item-details .subcategory-item");
      subcategoryEl.textContent = initiatedSubcategory;
    }
    if (isInitiatedConditionUnsellable) {
      const recycleItemEl = this.querySelector(".cart__item-details .recycle-item");
      recycleItemEl.textContent = recycleLabel;
    }
    if (rejectedReason) {
      const rejectedReasonEl = this.querySelector(".cart__item-details .rejected-reason");
      rejectedReasonEl.textContent = rejectedReason;
    }
  }

  async renderItem(item) {
    const urlParams = new URLSearchParams(window.location.search);
    const tradeinUuid = urlParams.get('tradeinuuid');
    let tradeInData;
    if (tradeinUuid) {
      tradeInData = await getTradein(tradeinUuid);
    }

    const imageContainer = document.createElement("div");
    imageContainer.classList.add("cart__item-list-body", "cart__item-media");

    const imageElement = document.createElement("img");
    let itemImage = item?.itemImageUrl;
    if (!itemImage) {
      itemImage = this.getAttribute("fallback");
    }

    imageElement?.setAttribute("src", normalizeUrl(itemImage, {width: '200', height: '200'}));
    imageContainer.appendChild(imageElement);

    this.appendChild(imageContainer);

    this.setAttribute("uuid", item.uuid);
    this.renderDetails(item);

    if (tradeInData?.state === 'TRADEIN_PROCESSED' || tradeInData?.state === 'TRADEIN_COMPLETED') {
      this.createCreditRangeElement(
        item.tradeinPrice,
        item.tradeinPrice,
        item.tradeinPrice,
      );
    } else {
      this.createCreditRangeElement(
        item.tradeinValueLow,
        item.tradeinValueHigh,
        item.tradeinValueHighDisplay,
      );
    }

    const removeItemLink = this.querySelector('.remove-link');
    if (removeItemLink) {
      removeItemLink.addEventListener("click", () => {
        this.removeItem(item.uuid);
      });
    }
    if (hideRemoveButton) {
      const removeButton = this.querySelector('.cart__remove-button-wrapper');
      removeButton.classList.add('hidden');
    }
  }

  async removeItem(tradeinItemUuid) {
    const itemList = this.closest('trade-in-item-list');
    const removeItem = itemList.querySelector(`[uuid="${tradeinItemUuid}"]`);
    removeItem.classList.add('loading');

    // Send the network request to delete the item from the tradein cart
    const tradeinUuid = localStorage.getItem('tradeinUuid');
    const updatedTradein = await removeItemFromTradein(tradeinUuid, tradeinItemUuid);
    const updatedItemsInCart = updatedTradein.tradeinItems;

    const tradeinCartIcon = document.querySelector('trade-in-cart-icon-bubble');
    tradeinCartIcon.setCount(updatedItemsInCart?.length);

    // Re-render the various UI elements of the tradein cart
    removeItem.classList.remove('loading');

    validateCart(updatedItemsInCart);

    if (updatedItemsInCart.length === 0) {
      // reload the page to trigger empty cart
      location.reload();
    } else {
      itemList.renderTradeInItems(updatedItemsInCart);

      const numberOfItemsHeader = document.querySelector('trade-in-cart-item-count');
      numberOfItemsHeader?.renderNumberCartItems(updatedItemsInCart.length);

      const shippingEstimate = await getShippingEstimate(global.partnerUuid)

      const tradeInCartFooter = document.querySelector('trade-in-cart-footer');
      tradeInCartFooter?.renderFooter(updatedItemsInCart, shippingEstimate);
    }
  }
}

customElements.define("trade-in-item", TradeInItem);
